<div class="enhance-container container">
  <h1 i18n>Enhance Your Culinary Journey, Exclusive Services for Our Chefs</h1>

  <div *ngFor="let item of list">

    <enhance-service-item
      [direction]="item.direction"
      [image]="item.image"
      [subtitle]="item.subtitle"
      [title]="item.title"
    ></enhance-service-item>
  </div>

</div>
